import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  deleteMacroPayloadType,
  GetMacroPayloadType,
  getSingleMacroPayloadType,
  MacroPatchPayloadType,
  MacrosState,
  MacrosStateContent,
  selectedMacroDataType,
} from '../types'

const initialState: MacrosState = {
  content: {},
  selected: null,
}

const macrosSlice = createSlice({
  name: 'Macros',
  initialState: initialState,
  reducers: {
    updateMacrosContent: (
      state: MacrosState,
      action: PayloadAction<MacrosStateContent | null>
    ) => {
      state.content = action.payload
    },
    updateSelectedMacro: (
      state: MacrosState,
      action: PayloadAction<selectedMacroDataType | null>
    ) => {
      if (action?.payload) {
        state.selected = action.payload
      }
    },
    resetSelectedMacro: (state: MacrosState) => {
      state.selected = null
    },
    getAllMacrosAction: (
      state: MacrosState,
      _action: PayloadAction<GetMacroPayloadType>
    ) => {
      return state
    },
    getSingleMacroAction: (
      state: MacrosState,
      _action: PayloadAction<getSingleMacroPayloadType>
    ) => {
      return state
    },
    patchSingleMacroAction: (
      state: MacrosState,
      _action: PayloadAction<MacroPatchPayloadType>
    ) => {
      return state
    },
    deleteMacroAction: (
      state: MacrosState,
      _action: PayloadAction<deleteMacroPayloadType>
    ) => {
      return state
    },
  },
})

export const {
  updateMacrosContent,
  updateSelectedMacro,
  resetSelectedMacro,
  getAllMacrosAction,
  getSingleMacroAction,
  patchSingleMacroAction,
  deleteMacroAction,
} = macrosSlice.actions
export default macrosSlice.reducer
